import { useEffect, useReducer, useRef, useState } from "react";

export const useDetailHeader = () => {
  const [showText, toggleShowText] = useReducer(
    (state: boolean) => !state,
    false
  );
  const [isLongText, setIsLongText] = useState(true);

  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      if (!textRef.current) return;

      setIsLongText(textRef.current.scrollHeight > 72);
    });

    return () => cancelAnimationFrame(frame);
  }, []);

  return {
    textRef,
    showText,
    isLongText,
    visibleShowMore: !showText && isLongText,
    toggleShowText,
  };
};
